import { defineAsyncComponent, defineComponent } from 'vue';

export default defineComponent({
	forms: {
		edit: {
			panel: {
				width: '90%',
				// Карта — корневая вкладка; не вкладывать под другую открытую карту
				parentKey: null,
			},
			component: defineAsyncComponent(() => import('./Edit/index.vue'))
		},
		list: {
			component: defineAsyncComponent(() => import('./List/index.vue'))
		},
		select: {
			panel: {
				width: '70%',
				height: '500px'
			},
			config: {
				fields: {
					status: {
					},
					name: {
					}
				}
			},
			component: defineAsyncComponent(() => import('./Select/index.vue'))
		}
	}
})